import styled from 'styled-components'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { INTRO_ACCENT_COLOR } from '~/pages/history/intro/libs/components/History/constants'
import { Button } from '~/shared/components/Button'
import { BREAKPOINTS, COLORS } from '~/shared/constants/uiConstants'

export const HistoryIntroStyles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #eeeef9;
    overflow: hidden;

    ${anatomyCompact} {
      overflow-y: auto;
    }
  `,

  ContentWrapper: styled.div`
    max-width: ${BREAKPOINTS[375]}px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    padding: 24px 16px 32px;
  `,

  Title: styled.h1`
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    text-align: center;
    color: ${COLORS.BLACK};
    margin-bottom: 10px;

    span {
      color: ${INTRO_ACCENT_COLOR};
      font-weight: inherit;
    }

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f32};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh38};
    }
  `,

  Subtitle: styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: ${COLORS.GRAY_700};
    margin-bottom: 24px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f15};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh20};
      margin-bottom: ${ANATOMY_COMPACT.spacing.s24};
    }
  `,

  BottomSection: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: auto;
  `,

  Image: styled.img`
    max-height: min(360px, 45dvh);
    object-fit: contain;
    width: 100%;
    margin-bottom: 16px;
  `,

  StyledButton: styled(Button)`
    width: 100%;
  `,
}
